import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type CRMType as ParameterCRMType } from '../parameters/CRMType';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @description Disables CRM integration
 * @tags Integrations
 * @summary Disable CRM integration
 */
export const DisableCRMIntegrationContentType = '' as const;
export type DisableCRMIntegrationRequest = void;
export type DisableCRMIntegrationResponses = LinkCommonErrorResponses & {};
export type DisableCRMIntegrationResponseSuccess = undefined;
export type DisableCRMIntegrationSearchParams = ParameterCRMType['query'];
export type DisableCRMIntegrationPathParameters = ParameterCRMType['path'];
export const DisableCRMIntegrationUrl = '/integrations/crm/disable' as const;
export const DisableCRMIntegrationMethod = 'POST' as const;
export const getDisableCRMIntegrationUrl = (_params?: DisableCRMIntegrationPathParameters) => DisableCRMIntegrationUrl;
